module.exports = __webpack_public_path__ + "static/media/marketing-1.d787eec5.jpg";